// extracted by mini-css-extract-plugin
module.exports = {"itemText":"_24d3828","avatar":"_8dcc0c7"};